// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"p1-z"};